import { memo } from "react";
import { ActivityIndicator, StyleSheet } from "react-native";
import Animated, { FadeIn } from "react-native-reanimated";
import { Text } from "@src/components";
import { useUnistyles } from "react-native-unistyles";

/** Dimmed overlay, centred spinner. */
export const LoadingOverlay = memo(({ message }: { message?: string }) => {
  const { theme } = useUnistyles();
  return (
    <Animated.View
      entering={FadeIn.duration(400)}
      style={[StyleSheet.absoluteFillObject, s.center, { backgroundColor: "rgba(0,0,0,0.4)" }]}
    >
      <ActivityIndicator size="large" color={theme.colors.white.default} />
      {message && (
        <Text textStyle="md/regular" style={{ color: theme.colors.white.default }} mt="lg">
          {message}
        </Text>
      )}
    </Animated.View>
  );
});

const s = StyleSheet.create({
  center: { justifyContent: "center", alignItems: "center", zIndex: 10 },
});
